import { render, staticRenderFns } from "./BCXMessengerChatGroupPreview.vue?vue&type=template&id=5c4acd84&scoped=true"
import script from "./BCXMessengerChatGroupPreview.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCXMessengerChatGroupPreview.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BCXMessengerChatGroupPreview.vue?vue&type=style&index=0&id=5c4acd84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4acd84",
  null
  
)

export default component.exports